export default "__VITE_ASSET__35681644__"